<template>
	<CreationWizardStepHeaderWrapper v-bind="headerWrapperProps" v-on="headerWrapperListeners">
		<div class="display-flex flex-wrap">
			<ButtonDropdownHeaderDataProvider class="flex-col-12" :appId="selectedAppId" />
			<ContextHeaderDataProvider class="flex-col-12" elementType="Button dropdown" :placementId="selectedPlacementId" />
		</div>
	</CreationWizardStepHeaderWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';
import props from './NeedPlyExtensionToUseButtonDropdown.props';
import ButtonDropdownHeaderDataProvider from '../common/ButtonDropdownHeaderDataProvider.vue';
import ContextHeaderDataProvider from '../common/ContextHeaderDataProvider.vue';

export default {
	name: 'NeedChromeToUseAddOnHeader',
	mixins: [WizardStepMixin],
	props,
	components: { ButtonDropdownHeaderDataProvider, ContextHeaderDataProvider },
};
</script>

<style lang="scss" scoped></style>
